import { Address } from 'viem';

export const mezoCbBtcTokenAddress: Address = '0x6a7CD8E1384d49f502b4A4CE9aC9eb320835c5d7';
